export default {
	"59f427f8a784f5dfd334c24fcba8d0ea": "暂时无法购买",
	"d7d69f044ea5e5933ca6abc5feeb136e": "请前往叫叫APP购买",
	"03add21c28182a5ede3db8319261dec3": "取消",
	"064de6394cb32ac98107b8d4bbb0124b": "前往叫叫APP"
}
